module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAogAAAIiAQMAAABxAKtxAAAAA1BMVEUAAACnej3aAAAAAXRSTlMAQObYZgAAAEJJREFUeNrtwTEBAAAAwiD7p7bGDmAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAZByu5AABmXR28AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/xingtu-loading-0.png
// module id = 8jeA
// module chunks = 0